module.exports = __webpack_public_path__ + "img/logo4.da734aae.png";